import React from "react";
import { Toaster } from "sonner";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MasterclassForm from "./MasterclassForm";
import MasterclassAdmin from "./MasterclassAdmin";
import ErrorBoundary from "./components/ErrorBoundary";
import { clearAll } from "./masterclassStorage";
import { SUPPORT_EMAIL } from "./masterclassConfig";
import AdminPage from "./AdminPage";
import FeedbackPage from "./FeedbackPage";

const App = () => {
  return (
    <Router>
      <>
        <Toaster richColors position="top-right" />
        <Routes>
          {/* AI Masterclass registration */}
          <Route
            path="/"
            element={
              <ErrorBoundary onReset={clearAll} supportEmail={SUPPORT_EMAIL}>
                <MasterclassForm />
              </ErrorBoundary>
            }
          />

          {/* Masterclass admin */}
          <Route path="/admin" element={<MasterclassAdmin />} />

          {/* Old bootcamp admin (read-only archive). The bootcamp form (UserForm.js) is no longer routed. */}
          <Route path="/admin/bootcamp" element={<AdminPage />} />

          <Route path="/feedback" element={<FeedbackPage />} />
        </Routes>
      </>
    </Router>
  );
};

export default App;
